import { useForm } from 'react-hook-form';

// Fase 5.17 (05-remediation.md) -- `TaskCreateWizard.jsx` (presentacional) importaba
// `react-hook-form` directo. El wizard usa la instancia de `useForm` como store de estado del
// formulario (setValue/getValues/watch/errors) — no hay `register` ni `FormProvider`. Se
// encapsula acá para que el componente no cruce la regla de frontera; el objeto `form` se
// devuelve tal cual, comportamiento idéntico.
export function useTaskCreateWizardForm() {
    return useForm({
        defaultValues: { title: '', description: '', assignee: '', duration: 15, supervisor: '' },
    });
}
